import { render, staticRenderFns } from "./ServerLink.vue?vue&type=template&id=7a4e66c8&"
import script from "./ServerLink.vue?vue&type=script&lang=js&"
export * from "./ServerLink.vue?vue&type=script&lang=js&"
import style0 from "./ServerLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports